import { Box, Tabs, Tab, styled } from '@mui/material'
import { useState } from 'react'
import { HeaderLarge } from '../../../components/typography/Header'

function TabPanel({ value, index, children }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && children}
    </div>
  )
}

function ManageTabs({ title, labels, panels }) {
  const [tabIndex, setTabIndex] = useState(0)

  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex)
  }

  const StyledTab = styled(Tab)`
    background-color: inherit;
    color: var(--gray);
    font-family: inherit;
    font-size: var(--md);
    font-weight: 700;
    border: none;
    padding: 12px 18px;
    cursor: pointer;
    text-transform: none;

    &:active {
      color: var(--primary);
    }
  `

  return (
    <>
      <HeaderLarge>{title}</HeaderLarge>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          className="tabs-container"
          value={tabIndex}
          onChange={handleTabChange}
        >
          {labels.map((label) => (
            <StyledTab className="tab-item" label={label} />
          ))}
        </Tabs>
      </Box>

      {panels.map((panel, index) => (
        <TabPanel value={tabIndex} index={index}>
          {panel}
        </TabPanel>
      ))}
    </>
  )
}

export default ManageTabs
